import { useState } from "react";
import { useCurentUser } from "../../actions/authActions";
export const useAdminProfile = () => {
  const userId = localStorage.getItem("userId");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const { data: userData, isLoading } = useCurentUser(userId);
  const handleContinueClick = () => {
    setShowPopup(true);
  };

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return {
    isMenuOpen,
    showPopup,
    handleContinueClick,
    closePopup,
    userData,
    isLoading,
    handleMenuClick,
  };
};
